/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ companyName: NonNullable<unknown> }} Help_Forreachout2Inputs */

const en_help_forreachout2 = /** @type {(inputs: Help_Forreachout2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(for institutional investors) or if you are an ${i?.companyName} employee, reach out to`)
};

/**
* | output |
* | --- |
* | "(for institutional investors) or if you are an {companyName} employee, reach out to" |
*
* @param {Help_Forreachout2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const help_forreachout2 = /** @type {((inputs: Help_Forreachout2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Forreachout2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_forreachout2(inputs)
});
export { help_forreachout2 as "help_forReachOut" }